import { render, staticRenderFns } from "./ElTextarea.vue?vue&type=template&id=079b90b1&"
import script from "./ElTextarea.vue?vue&type=script&lang=js&"
export * from "./ElTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports